import React, { useCallback, useEffect, useState } from "react";
import api from "../lib/api";
import { fmtMoney } from "../components/Format";

export default function Admin() {
  const [stats, setStats] = useState(null);
  const [users, setUsers] = useState([]);

  const refresh = useCallback(async () => {
    try {
      const [s, u] = await Promise.all([api.get("/admin/stats"), api.get("/admin/users")]);
      setStats(s.data); setUsers(u.data);
    } catch { /* ignore transient refresh failures */ }
  }, []);

  useEffect(() => {
    refresh();
    const id = setInterval(refresh, 4000);
    return () => clearInterval(id);
  }, [refresh]);

  return (
    <div className="space-y-6" data-testid="admin-page">
      <div>
        <div className="label-xs">Platform</div>
        <h1 className="text-3xl font-[Chivo] tracking-tight">Admin Console</h1>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-px bg-border">
        <Stat label="Users" value={stats?.users ?? 0} />
        <Stat label="Bots" value={stats?.bots ?? 0} />
        <Stat label="Running" value={stats?.running_bots ?? 0} />
        <Stat label="Trades" value={stats?.trades ?? 0} />
        <Stat label="Volume" value={`$${fmtMoney(stats?.total_volume ?? 0, 0)}`} />
        <Stat label="Total PnL" value={`${(stats?.total_pnl ?? 0) >= 0 ? "+" : ""}$${fmtMoney(stats?.total_pnl ?? 0)}`}
              color={(stats?.total_pnl ?? 0) >= 0 ? "#00E676" : "#FF3B30"} />
      </div>

      <div className="border border-border bg-[#0F0F0F]">
        <div className="px-4 py-3 border-b border-border label-xs">Users</div>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-border">
              <th className="text-left px-3 py-2 label-xs">Name</th>
              <th className="text-left px-3 py-2 label-xs">Email</th>
              <th className="text-left px-3 py-2 label-xs">Role</th>
              <th className="text-left px-3 py-2 label-xs">Joined</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-b border-border hover:bg-[#141414]" data-testid={`admin-user-${u.id}`}>
                <td className="px-3 py-2 font-[Chivo]">{u.name}</td>
                <td className="px-3 py-2 text-neutral-400">{u.email}</td>
                <td className="px-3 py-2">
                  <span className={`text-xs px-2 py-0.5 border ${u.role === "admin" ? "border-[#FFB300] text-[#FFB300]" : "border-neutral-700 text-neutral-400"}`}>
                    {u.role}
                  </span>
                </td>
                <td className="px-3 py-2 num text-xs text-neutral-500">{new Date(u.created_at).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

function Stat({ label, value, color }) {
  return (
    <div className="bg-[#0F0F0F] px-5 py-4">
      <div className="label-xs">{label}</div>
      <div className="num text-2xl font-[Chivo] mt-2" style={{ color: color || "#fff" }}>{value}</div>
    </div>
  );
}
